import React, { useEffect, useState } from "react";
import { useTheme } from "next-themes";

// Theme-aware brand logo.
// - Dark theme  -> /logo.png       (lime tile, black runner)
// - Light theme -> /logo-light.png (dark-grey tile, lime runner)
export const Logo = ({ className = "h-8 w-8 rounded-lg", alt = "Real Deal Fitness", ...rest }) => {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const src = mounted && resolvedTheme === "light" ? "/logo-light.png" : "/logo.png";
  return <img src={src} alt={alt} className={className} {...rest} />;
};

export default Logo;
